import { EnvConfig } from 'src/configurations'
import Cookies from 'universal-cookie'

export enum CookieNames {
  App = 'app',
  Authed = 'authed',
  Home = 'home',
  YourCardsOverview = 'your_cards_overview',
  YourCardsInactive = 'your_cards_inactive',
  YourCardsActive = 'your_cards_active',
  AccountsYourAccounts = 'accounts_your_accounts',
  AccountsVirtualCards = 'accounts_virtual_cards',
  AccountOverview = 'account_overview',
  AccountVirtualCards = 'account_virtual_cards',
  BudgetsVirtualCards = 'budgets_virtual_cards',
  CreateVirtualCard = 'create_virtual_card',
  CreateBudget = 'create_budget',
  RequestVirtualCard = 'request_virtual_card',
  People = 'people',
  Onboarding = 'onboarding',
  FeatureFlagger = 'feature_flagger',
  NavBar = 'nav_bar',
  Transactions = 'transactions',
  Expenses = 'expenses',
  Unauthed = 'unauthed',
}

export enum CookieValuePaths {
  isRegisterAccountPromoOpen = 'is_register_account_promo_open',
  isCreateABudgetPromoOpen = 'is_create_a_budget_promo_open',
  isAddAnotherAccountPromoOpen = 'is_add_another_account_promo_open',
  isAddAnotherAccountHomePromoOpen = 'is_add_another_account_home_promo_open',
  firstLogin = 'first_login',
  shouldShowRequestCardPromo = 'should_show_request_card_promo',
  shouldShowAccountTutorialPromo = 'should_show_register_account_promo',
  shouldShowVirtualCardsPromo = 'should_show_virtual_cards_promo',
  shouldShowUpdateRoleListPromo = 'should_show_update_role_list_promo',
  bmoWelcomePopupOpen = 'bmo_welcome_popup_open',
  isIntegrationsPromoOpen = 'is_integrations_promo_open',
  shouldShowTransactionReconciliationPromo = 'should_show_transactions_reconciliation_promo',
  shouldShowBudgetVirtualCardsPromo = 'show_budget_virtual_cards_promo',
  coBrandWelcomePopupOpen = 'cobrand_welcome_popup_open',
  unauthedLocale = 'unauthed_locale',
  checkedSecondReportCycleDate = 'checked_second_report_cycle_date',
  shouldShowBulkEditTransactionsSpotlightPromo = 'should_show_bulk_edit_transactions_spotlight_promo',
  cachedAlertStats = 'cached_alert_stats',
  shouldShowRulesWhatsNew = 'should_show_rules_whats_new',
  shouldShowDowngradedToStarterModal = 'should_show_downgraded_to_starter_modal',
}

export const jwtCookieName = (envConfig: EnvConfig): string =>
  `extend_app_jwt_${envConfig.ENVIRONMENT}`
export const getJwtCookie = (
  envConfig: EnvConfig,
  cookie: string | undefined,
): string | undefined => {
  const cookies = new Cookies(cookie)
  return cookies.get(jwtCookieName(envConfig))
}
export const setJwtCookie = (envConfig: EnvConfig, jwt?: string): void => {
  const cookies = new Cookies()
  cookies.set(jwtCookieName(envConfig), jwt, {
    path: '/',
    expires: new Date('January 1, 3000 00:00:00'),
  })
}

export const refreshTokenCookieName = (envConfig: EnvConfig): string =>
  `extend_app_refresh_token_${envConfig.ENVIRONMENT}`
export const getRefreshTokenCookie = (
  envConfig: EnvConfig,
  cookie: string | undefined,
): string | undefined => {
  const cookies = new Cookies(cookie)
  return cookies.get(refreshTokenCookieName(envConfig))
}
export const setRefreshTokenCookie = (
  envConfig: EnvConfig,
  refreshToken?: string,
): void => {
  const cookies = new Cookies()
  cookies.set(refreshTokenCookieName(envConfig), refreshToken, {
    path: '/',
    expires: new Date('January 1, 3000 00:00:00'),
  })
}

export const cspJwtCookieName = (envConfig: EnvConfig): string =>
  `extend_app_csp_jwt_${envConfig.ENVIRONMENT}`
export const getCspJwtCookie = (
  envConfig: EnvConfig,
  cookie: string | undefined,
): string | undefined => {
  const cookies = new Cookies(cookie)
  return cookies.get(cspJwtCookieName(envConfig))
}
export const setCspJwtCookie = (envConfig: EnvConfig, jwt?: string): void => {
  const cookies = new Cookies()
  cookies.set(cspJwtCookieName(envConfig), jwt, {
    path: '/',
    expires: new Date('January 1, 3000 00:00:00'),
  })
}

export const cspRefreshTokenCookieName = (envConfig: EnvConfig): string =>
  `extend_app_csp_refresh_token_${envConfig.ENVIRONMENT}`
export const getCspRefreshTokenCookie = (
  envConfig: EnvConfig,
  cookie: string | undefined,
): string | undefined => {
  const cookies = new Cookies(cookie)
  return cookies.get(cspRefreshTokenCookieName(envConfig))
}
export const setCspRefreshTokenCookie = (
  envConfig: EnvConfig,
  cspRefreshToken?: string,
): void => {
  const cookies = new Cookies()
  cookies.set(cspRefreshTokenCookieName(envConfig), cspRefreshToken, {
    path: '/',
    expires: new Date('January 1, 3000 00:00:00'),
  })
}

export const userSessionTokenIdCookieName = (envConfig: EnvConfig): string =>
  `extend_app_token_id_${envConfig.ENVIRONMENT}`
export const getUserSessionTokenIdCookie = (
  envConfig: EnvConfig,
  cookie: string | undefined,
): string | undefined => {
  const cookies = new Cookies(cookie)
  return cookies.get(userSessionTokenIdCookieName(envConfig))
}
export const setUserSessionTokenIdCookie = (
  envConfig: EnvConfig,
  userSessionTokenId?: string,
): void => {
  const cookies = new Cookies()
  cookies.set(userSessionTokenIdCookieName(envConfig), userSessionTokenId, {
    path: '/',
    expires: new Date('January 1, 3000 00:00:00'),
  })
}

export interface PerSessionValuesType {
  isBudgetWarningDismissed: boolean
  isConfirmOrgModalAccountAccountsDismissed: boolean
  isConfirmRCNOrBudgetModalAccountOverviewDismissed: boolean
  isConfirmBudgetModalAccountsBudgetsDismissed: boolean
  isConfirmBudgetModalCreateBudgetDismissed: boolean
  isConfirmBudgetModalUpdateBudgetDismissed: boolean
  isOrglessGuestCardWarningDismissed: boolean
  isOrgAdminUserWarningDismissed: boolean
  isAcceptOrgInvitePopupDismissed: boolean
  isOrglessUserWarningDismissed: boolean
  isBrandSuggestionPopupDismissed: boolean
}
export const defaultPerSessionValues = {
  isBudgetWarningDismissed: false,
  isConfirmOrgModalAccountAccountsDismissed: false,
  isConfirmRCNOrBudgetModalAccountOverviewDismissed: false,
  isConfirmBudgetModalAccountsBudgetsDismissed: false,
  isConfirmBudgetModalCreateBudgetDismissed: false,
  isConfirmBudgetModalUpdateBudgetDismissed: false,
  isOrglessGuestCardWarningDismissed: false,
  isOrgAdminUserWarningDismissed: false,
  isAcceptOrgInvitePopupDismissed: false,
  isOrglessUserWarningDismissed: false,
  isBrandSuggestionPopupDismissed: false,
}

export const perSessionValuesName = 'extend_app_per_session_values'

export const getPerSessionValuesCookie = (
  cookie?: string,
): PerSessionValuesType | undefined => {
  const cookies = new Cookies(cookie)
  return cookies.get(perSessionValuesName)
}
export const setPerSessionValuesCookie = (
  newValues: Partial<PerSessionValuesType>,
): void => {
  const cookies = new Cookies()
  cookies.set(perSessionValuesName, newValues, {
    path: '/',
    expires: new Date('January 1, 3000 00:00:00'),
  })
}

export type TransactionsDownloadFields = {
  includeAttachments: boolean
  registeredCardLast4: boolean
  registeredCardName: boolean
  transactionDate: boolean
  clearDate: boolean
  type: boolean
  status: boolean
  nameOnCard: boolean
  vcnRecipientEmail: boolean
  authorizationMerchantCurrency: boolean
  authorizationMerchantAmount: boolean
  authorizationBillingCurrency: boolean
  authorizationBillingAmount: boolean
  authorizationExchangeRate: boolean
  settlementMerchantCurrency: boolean
  settlementMerchantAmount: boolean
  settlementBillingCurrency: boolean
  settlementBillingAmount: boolean
  settlementExchangeRate: boolean
  merchantName: boolean
  merchantAddress: boolean
  merchantCity: boolean
  merchantState: boolean
  merchantCountry: boolean
  merchantZipPostal: boolean
  mcc: boolean
  mccDescription: boolean
  vcnSender: boolean
  vcnSenderEmail: boolean
  vcnNickname: boolean
  vcnLast4: boolean
  referenceId: boolean
  source: boolean
  external: boolean
  attachments: boolean
  transactionAmount: boolean
  notes: boolean
  transactionReceipt: boolean
  receipt: boolean
  vendor: boolean
  customer: boolean
  expenseCategories: boolean
  cardholderEmail: boolean
  authBillingAmountCents: boolean
  authBillingCurrency: boolean
  authMerchantAmountCents: boolean
  authMerchantCurrency: boolean
  authExchangeRate: boolean
  attachmentsCount: boolean
  creditCardDisplayName: boolean
  creditCardType: boolean
  team: boolean
  managerReviewStatus: boolean
}

export interface TransactionsCSVFields
  extends Omit<TransactionsDownloadFields, 'includeAttachments'> {}

export const transactionsDownloadFieldsName =
  'extend_app_transactions_download_fields'

export const getTransactionsDownloadFieldsCookie = (
  cookie?: string,
): TransactionsDownloadFields | undefined => {
  const cookies = new Cookies(cookie)
  return cookies.get(transactionsDownloadFieldsName)
}

export const setTransactionsDownloadFieldsCookie = (
  newValues: Partial<TransactionsDownloadFields>,
): void => {
  const cookies = new Cookies()
  const transactionDownloadFields = cookies.get(transactionsDownloadFieldsName)
  cookies.set(
    transactionsDownloadFieldsName,
    {
      ...transactionDownloadFields,
      ...newValues,
    },
    {
      path: '/',
      expires: new Date('January 1, 3000 00:00:00'),
    },
  )
}

export type TransactionsTableFields = {
  date: boolean
  merchant: boolean
  vendor: boolean
  card: boolean
  cardUser: boolean
  cardholderEmail: boolean
  expenseCategories: boolean
  status: boolean
  managerReviewStatus: boolean
  finalReview: boolean
  amount: boolean
  currency: boolean
  authBillingAmountCents: boolean
  authBillingCurrency: boolean
  authMerchantAmountCents: boolean
  authMerchantCurrency: boolean
  authExchangeRate: boolean
  attachmentsCount: boolean
  creditCardDisplayName: boolean
  creditCardType: boolean
  receipts: boolean
  txnSynced: boolean
  receiptsSynced: boolean
  originalMerchant: boolean
  chevron: boolean
}

export const transactionsTableFieldsName =
  'extend_app_transactions_table_fields'

export const getTransactionsTableFieldsCookie = (
  cookie?: string,
): TransactionsTableFields | undefined => {
  const cookies = new Cookies(cookie)
  return cookies.get(transactionsTableFieldsName)
}

export const setTransactionsTableFieldsCookie = (
  newValues: Partial<TransactionsTableFields>,
): void => {
  const cookies = new Cookies()
  const transactionTableFields = cookies.get(transactionsTableFieldsName)
  cookies.set(
    transactionsTableFieldsName,
    {
      ...transactionTableFields,
      ...newValues,
    },
    {
      path: '/',
      expires: new Date('January 1, 3000 00:00:00'),
    },
  )
}

export type VirtualCardsTableFields = {
  date: boolean
  cardName: boolean
  cardCreator: boolean
  cardUser: boolean
  cardType: boolean
  status: boolean
  activeUntil: boolean
  availableCredit: boolean
  details: boolean
}

export const virtualCardsTableFieldsName =
  'extend_app_virtual_cards_table_fields'

export const getVirtualCardsTableFieldsCookie = (
  cookie?: string,
): VirtualCardsTableFields | undefined => {
  const cookies = new Cookies(cookie)
  return cookies.get(virtualCardsTableFieldsName)
}

export const setVirtualCardsTableFieldsCookie = (
  newValues: Partial<VirtualCardsTableFields>,
): void => {
  const cookies = new Cookies()
  const virtualCardsTableFields = cookies.get(virtualCardsTableFieldsName)
  cookies.set(
    virtualCardsTableFieldsName,
    {
      ...virtualCardsTableFields,
      ...newValues,
    },
    {
      path: '/',
      expires: new Date('January 1, 3000 00:00:00'),
    },
  )
}
